import { createContext, useContext } from 'react';

export interface ChecklistContextType {
  checkedItems: Record<string, boolean>;
  toggleItem: (id: string) => void;
  variant: 'primary' | 'secondary';
}

export const ChecklistContext = createContext<ChecklistContextType | null>(
  null
);

export const useChecklistContext = () => {
  const context = useContext(ChecklistContext);
  if (!context) {
    throw new Error(
      'useChecklistContext must be used within a ChecklistContext.Provider component'
    );
  }
  return context;
};
